module.exports = __webpack_public_path__ + "static/media/mainCharForError1.f10425df.png";